import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// GET all notes for an employee
export const getEmployeeNotes = async (employeeId) => {
  const response = await api.get(`${API_URL}/notes/employee/${employeeId}`);
  return response.data;
};

// POST a new note for an employee
export const addEmployeeNote = async (employeeId, noteData) => {
  // FIX: Send 'noteData' directly as the body. Do NOT wrap it in { content: ... }
  const response = await api.post(`${API_URL}/notes/employee/${employeeId}`, noteData);
  return response.data;
};

// PUT update an existing note
export const updateEmployeeNote = async (noteId, noteData) => {
  // FIX: Send 'noteData' directly for updates as well
  const response = await api.put(`${API_URL}/notes/${noteId}`, noteData);
  return response.data;
};

// DELETE a note
export const deleteEmployeeNote = async (noteId) => {
  const response = await api.delete(`${API_URL}/notes/${noteId}`);
  return response.data;
};

// GET employees flagged for repeated feedback violations
export const getFlaggedEmployeesByFeedback = async (threshold = 3) => {
  const response = await api.get(`${API_URL}/notes/flags`, {
    params: { threshold },
  });
  return response.data;
};

// GET violations overview (all notes)
export const getViolationsOverview = async (params = {}) => {
  const response = await api.get(`${API_URL}/notes/violations/overview`, { params });
  return response.data;
};